import React, { createContext, useContext, useState } from "react";
import { ModalType } from "../components/authGuard";
import AuthModal from "../components/authModal";
import { useNavigate } from "react-router-dom";

interface ModalContextType {
  showModal: (type: ModalType) => void;
  hideModal: () => void;
}
const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const AuthModalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState<ModalType | null>(null);

  const showModal = (type: ModalType) => {
    setModalType(type);
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
    setModalType(null);
  };
  const navigate = useNavigate();

  return (
    <ModalContext.Provider value={{ showModal, hideModal }}>
      <AuthModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        modalType={modalType}
        navigate={navigate}
      />
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) throw new Error("useModal must be used within a ModalProvider");
  return context;
};
